import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import NumberField from '@/components/forms/new/formikFormFields/NumberField';
import {
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const OverstampField = ({
    submitData,
    setPlatformNumber,
    errors,
    touched,
    darkMode,
    section,
    platformID,
}) => {
    const platformIndex = submitData?.findIndex(
        (platform) => platform.platformID === platformID,
    );
    const platform = submitData[platformIndex];
    const handleChange = (e) => {
        setPlatformNumber((prev) => {
            const newPlatforms = [...prev];
            newPlatforms[platformIndex] = {
                ...platform,
                overstampNumber: parseInt(e.target.value, 10),
            };
            return newPlatforms;
        });
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                errors &&
                `${section}-overstamp` in errors &&
                touched &&
                touched[`${section}-overstamp`]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                sx={{ ...stackStyling(true), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Overstamp Number
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Setup temporary or long term number re-routing
                    </Text>
                </Box>

                <Field
                    component={NumberField}
                    walkthroughid={
                        walkthroughIds.editNumbersGeneral.editPlatformNumbers
                            .ufOverstamp
                    }
                    id={`${section}-overstamp`}
                    name={`${section}-overstamp`}
                    onChange={handleChange}
                    value={platform?.overstampNumber || ''}
                    displayPrefix="+"
                    inputProps={{
                        placeholder: 'Enter number',
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Overstamp Number"
                        ariaLabel={`${section}-overstamp-tooltip`}
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OverstampField;
